let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("3yAl4"), load("kNFvF"), load("ffQaD"), load("kvRbA"), load("fliVL"), load("6PtIC")]).then(() => parcelRequire('5tdjr'));